import {
  MODE_3D_VIEW,
  MODE_DRAGGING_ITEM,
  MODE_DRAGGING_VERTEX,
  MODE_DRAWING_ITEM,
  MODE_DRAWING_WALL,
  MODE_IDLE,
} from '@constants'
import { Area, SceneObjects, Store } from '@types'
import { isLightweightViewer } from '../viewport/readCapabilities'

import isArea from './sceneObjects/assertions/isArea'
import { isHoleOrItem } from './sceneObjects/assertions/isHoleOrItem'
import isWall from './sceneObjects/assertions/isWall'

export function deepDiff(
  obj1: Pick<Store, 'items' | 'areas' | 'mode' | 'layers'>,
  obj2: Pick<Store, 'items' | 'areas' | 'mode' | 'layers'>,
) {
  if (isLightweightViewer()) return null
  const devuelvo = { ...obj2 }
  if (
    (obj2.mode === MODE_3D_VIEW && obj1.mode === MODE_IDLE) ||
    (obj2.mode === MODE_IDLE && obj1.mode === MODE_3D_VIEW) ||
    (obj2.mode === MODE_DRAGGING_VERTEX && obj1.mode === MODE_DRAGGING_VERTEX) ||
    (obj2.mode === MODE_DRAWING_WALL && obj1.mode === MODE_DRAWING_WALL) ||
    (obj2.mode === MODE_DRAGGING_ITEM && obj1.mode === MODE_DRAGGING_ITEM) ||
    (obj1.mode === MODE_DRAGGING_ITEM && obj2.mode === MODE_IDLE) ||
    (obj1.mode === MODE_DRAWING_ITEM && obj2.mode === MODE_IDLE)
  ) {
    return null
  }
  if (obj1.mode === MODE_IDLE && obj2.mode === MODE_DRAGGING_ITEM) {
    return devuelvo
  }
  if (obj1.items && obj2.items && obj1.areas && obj2.areas) {
    const diffItems = mapDiff(obj1.items, obj2.items)
    const diffAreas = mapDiff(obj1.areas, obj2.areas)
    const diffOBB = mapDiff(obj1.sceneBoundingBoxes, obj2.sceneBoundingBoxes)
    const diffLayers = setDiff(obj1.layers[0].items, obj2.layers[0].items)
    if (!diffItems && !diffAreas && !diffLayers && !diffOBB) {
      return null
    }
  }

  return devuelvo
}
function setDiff(set1: Set<string>, set2: Set<string>): boolean {
  // Compare the sizes of the sets
  if (set1.size > set2.size) {
    return true
  } else if (set1.size < set2.size) {
    return true
  } else {
    return false
  }
}

function mapDiff(
  map1: Map<string, SceneObjects | Area>,
  map2: Map<string, SceneObjects | Area>,
): boolean {
  if (map1.size !== map2.size) {
    return true
  }
  for (const [key, value] of map1) {
    const map2Object = map2.get(key)
    if (!map2Object) return false
    if (map2Object.isBlocked !== value.isBlocked) {
      return true
    }
    //Paredes
    if (isWall(map2Object) && isWall(value)) {
      if (map2Object.x !== value.x || map2Object.y !== value.y || map2Object.z !== value.z) {
        return false
      }
      if (
        map2Object.width !== value.width ||
        map2Object.height !== value.height ||
        map2Object.thickness !== value.thickness
      ) {
        return true
      }
    }
    //Solo objetos y agujeros
    if (!isArea(value) && !isArea(map2Object)) {
      if (isHoleOrItem(map2Object) && isHoleOrItem(value)) {
        if (map2Object.matrix && value.matrix) {
          return !value.matrix.equals(map2Object.matrix)
        }
        if (map2Object.morphs && value.morphs) {
          if (map2Object.morphs.length !== value.morphs.length) {
            return true
          }

          for (let i = 0; i < value.morphs.length; i++) {
            if (map2Object.morphs[i] !== value.morphs[i]) {
              return true
            }
          }
        }
      }
    }
    // Objetos, agujeros y areas
    if (
      (isArea(value) && isArea(map2Object)) ||
      (isWall(map2Object) && isWall(value)) ||
      (isHoleOrItem(map2Object) && isHoleOrItem(value))
    ) {
      if (map2Object.textures && value.textures) {
        if (map2Object.textures.length !== value.textures.length) {
          return true
        }

        for (let i = 0; i < value.textures.length; i++) {
          if (map2Object.textures[i] !== value.textures[i]) {
            return true
          }
        }
      }
      if (map2Object.zones && value.zones) {
        const map2ObjectKeys = Object.keys(map2Object.zones)
        const valueKeys = Object.keys(value.zones)

        if (map2ObjectKeys.length !== valueKeys.length) {
          return true
        }

        for (let i = 0; i < valueKeys.length; i++) {
          const key = valueKeys[i]
          if (map2Object.zones[key] !== value.zones[key]) {
            return true
          }
        }
        if (map2Object.morphs && value.morphs) {
          if (map2Object.morphs.length !== value.morphs.length) {
            return true
          }

          for (let i = 0; i < value.morphs.length; i++) {
            if (map2Object.morphs[i] !== value.morphs[i]) {
              return true
            }
          }
        }
      }
    }
  }
  return false
}
